import { log } from 'console';
import { APICore } from './apiCore';

const api = new APICore();

export function contactList() {
    return api.get('/contact/list');
}

export function contactAdd(data: any) {
    console.log('data>', data);

    const formData = new FormData();
    formData.append('icon', data.data.icon);
    formData.append('label', data.data.label);
    formData.append('value', data.data.value);
    formData.append('linking_url', data.data.linking_url);

    return api.create('/contact/add', formData);
}

export function contactDelete(data: any) {
    return api.delete('/contact/delete', data);
}

export function contactUpdate(data: any) {
    console.log('datato update>', data);

    const formData = new FormData();
    formData.append('icon', data.data.icon);
    formData.append('label', data.data.label);
    formData.append('value', data.data.value);
    formData.append('linking_url', data.data.linking_url);
    formData.append('contact_id', data.data.contact_id);

    return api.update('/contact/update', formData);
}

export function contactUpdateSeq(data: any) {
    return api.update('/contact/update/seq', data);
}
